// @noflow
import './buttons-link.component.css';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';

HrefButton.propTypes = {
    alternate: PropTypes.bool,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    href: PropTypes.string,
    target: PropTypes.string
};

export default function HrefButton({ alternate, children, className, href, target, ...props }) {
    const linkClasses = {
        'link-button': true,
        'link-button--alternate': alternate,
        [className]: className != null
    };

    return (
        <a className={classnames(linkClasses)} href={href} target={target} {...props}>
            {children}
        </a>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/buttons/link/buttons-href.component.js